import HeadedModal from '@paradigm/design-system/src/components/HeadedModal';

interface Props {
  readonly isOpen: boolean;
  readonly close: () => void;
}

export default function NoRfqFound({ isOpen, close }: Props) {
  return (
    <HeadedModal title="Quote" isOpen={isOpen} close={close}>
      <p
        data-testid="quote_builder_missing_rfq"
        css="color: #ffffff; opacity: 0.7; margin: 2rem; text-align: center"
      >
        RFQ no longer available
      </p>
    </HeadedModal>
  );
}
